<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between pb-1 align-items-center">
        <h1 class="font-weight-bolder">
          {{ $t('myQuotes') }}
        </h1>
        <b-button
          variant="primary"
          @click="createQuote"
        >
          {{ $t('create', { type: $t('quote') }) }}
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-overlay :show="loading && quotes.length > 0">
          <quotes-table
            :quotes="quotes"
            :loading="loading"
            empty-title="Todavía no tienes cotizaciones en esta obra"
            empty-hint="Crea una cotización y te conseguimos precios de los proveedores de la zona."
            :show-invoice-column="false"
            @sort-changed="handleSort"
            @quote-deleted="refreshQuotes"
            @quote-nickname-updated="refreshQuotes"
            @quote-requoted="onRequoteQuote"
          />
        </b-overlay>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-flex justify-content-end">
        <b-pagination
          :value="quotesPagination.page"
          :total-rows="quotesPagination.total_objects"
          :per-page="quotesPagination.per_page"
          aria-controls="my-table"
          @change="nextPage($event)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import QuotesTable from '@/components/pricing/QuotesTable.vue'

export default {
  components: {
    QuotesTable,
  },

  data() {
    return {
      loading: false,
      sortField: null,
      sortDirection: null,
    }
  },

  computed: {
    ...mapGetters('quotes', ['quotes', 'quotesPagination']),
    ...mapGetters('projects', ['project']),
    ...mapGetters('auth', ['currentUser']),
  },

  created() {
    this.loading = true
    Promise.all([
      this.fetchQuotes({
        by_project: this.$route.params.projectId,
        by_payment_status: '0,3',
      }),
      this.fetchProject(this.$route.params.projectId),
    ]).then(() => {
      this.loading = false
    })
  },

  destroyed() {
    this.clearQuotes()
    // this.clearProject({})
  },

  methods: {
    ...mapMutations('quotes', {
      clearQuotes: 'CLEAR_QUOTES',
      changePagination: 'CHANGE_PAGINATION',
    }),
    ...mapMutations('projects', {
      clearProject: 'SET_PROJECT',
    }),
    ...mapActions('quotes', ['fetchQuotes', 'addQuote', 'requoteQuote']),
    ...mapActions('projects', ['fetchProject']),

    nextPage(value) {
      this.changePagination({ field: 'page', value })
      this.loading = true

      const fetchParams = {
        by_project: this.$route.params.projectId,
        by_payment_status: '0,3',
        meta: { pagination: this.quotesPagination },
      }

      if (this.sortField && this.sortDirection) {
        fetchParams.sort = `${this.sortField}:${this.sortDirection}`
      }

      this.fetchQuotes(fetchParams).then(() => {
        this.loading = false
      })
    },

    createQuote() {
      const quote = {}
      quote.address_attributes = { ...this.project.address }
      quote.project_id = this.$route.params.projectId
      this.addQuote({
        ...quote,
      }).then(response => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('quoteCreated'),
            icon: 'EditIcon',
            variant: 'success',
          },
        })
        this.$router.push({
          name: 'addProductsToQuote',
          params: { quoteId: response.id },
        })
      })
    },

    handleSort({ field, direction }) {
      this.sortField = field
      this.sortDirection = direction
      this.loading = true

      this.fetchQuotes({
        by_project: this.$route.params.projectId,
        by_payment_status: '0,3',
        sort: `${field}:${direction}`,
        meta: {
          pagination: {
            page: this.quotesPagination.page,
            per_page: this.quotesPagination.per_page,
          },
        },
      }).then(() => {
        this.loading = false
      })
    },
    refreshQuotes() {
      return this.fetchQuotes({
        by_project: this.$route.params.projectId,
        by_payment_status: '0,3',
        meta: {
          pagination: this.quotesPagination,
        },
      })
    },
    async onRequoteQuote(sourceQuoteId) {
      try {
        this.loading = true

        const newQuote = await this.requoteQuote(sourceQuoteId)

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('quoteRequoted'),
            icon: 'CopyIcon',
            variant: 'success',
          },
        })

        if (String(newQuote.id) === String(sourceQuoteId)) {
          await this.refreshQuotes()
          return
        }

        this.$router.push({
          name: 'addProductsToQuote',
          params: { quoteId: newQuote.id },
        })
      } catch (err) {
        const msg = err?.data?.messages?.[0] || err?.statusText || this.$t('quoteRequoteFailed')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: msg,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loading = false
      }
    },

  },
}
</script>

<style></style>
